(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-metafields"] && !Shopify.designMode) return;
  try {
    (() => {
    const MOBILE_QUERY = '(max-width: 1023px)';
    const ROW_KEYS = ['tasting_notes', 'region', 'cultivar'];
    const TOP_TOLERANCE = 24;
    let frameId = 0;
    let resizeTimer = 0;

    function clearHeights() {
      document.querySelectorAll('[data-metafield-row]').forEach((row) => {
        row.style.minHeight = '';
      });
    }

    function getAnchor(table) {
      return (
        table.closest('li') ||
        table.closest('data-island') ||
        table.closest('.product-card-metafields') ||
        table
      );
    }

    function groupTables(tables) {
      const groups = [];

      tables.forEach((table) => {
        const top = Math.round(getAnchor(table).getBoundingClientRect().top + window.scrollY);
        let group = groups.find((entry) => Math.abs(entry.top - top) <= TOP_TOLERANCE);

        if (!group) {
          group = { top, tables: [] };
          groups.push(group);
        }

        group.tables.push(table);
      });

      return groups;
    }

    function syncMetafieldRowHeights() {
      clearHeights();

      if (!window.matchMedia(MOBILE_QUERY).matches) return;

      const tables = Array.from(document.querySelectorAll('.product-card-metafields__table'));
      if (tables.length < 2) return;

      groupTables(tables).forEach(({ tables: rowTables }) => {
        if (rowTables.length < 2) return;

        ROW_KEYS.forEach((key) => {
          const rows = rowTables
            .map((table) => table.querySelector(`[data-metafield-row="${key}"]`))
            .filter(Boolean);

          if (rows.length < 2) return;

          const maxHeight = Math.max(...rows.map((row) => row.getBoundingClientRect().height));
          rows.forEach((row) => {
            row.style.minHeight = `${maxHeight}px`;
          });
        });
      });
    }

    function scheduleSync() {
      if (frameId) cancelAnimationFrame(frameId);
      frameId = requestAnimationFrame(() => {
        frameId = 0;
        syncMetafieldRowHeights();
      });
    }

    function scheduleSyncDebounced() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(scheduleSync, 100);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
    } else {
      scheduleSync();
    }

    window.addEventListener('resize', scheduleSyncDebounced);
    window.addEventListener('load', scheduleSync);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleSync).catch(() => {});
    }

    const observer = new MutationObserver(scheduleSyncDebounced);
    observer.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
